import { fetchApi } from '../utils/helpers';
import constants from '../constants';

const {
  FETCH_ADDITIONAL_HORSES_REQUEST,
  FETCH_ADDITIONAL_HORSES_SUCCESS,
  FETCH_ADDITIONAL_HORSES_FAILURE,
  CREATE_ADDITIONAL_HORSE_REQUEST,
  CREATE_ADDITIONAL_HORSE_SUCCESS,
  CREATE_ADDITIONAL_HORSE_FAILURE,
  DELETE_ADDITIONAL_HORSE_REQUEST,
  DELETE_ADDITIONAL_HORSE_SUCCESS,
  DELETE_ADDITIONAL_HORSE_FAILURE,
  EDIT_ADDITIONAL_HORSE_REQUEST,
  EDIT_ADDITIONAL_HORSE_SUCCESS,
  EDIT_ADDITIONAL_HORSE_FAILURE,
} = constants;

/**
 * Fetch horses
 */
export const fetchHorsesSuccess = data => ({
  type: FETCH_ADDITIONAL_HORSES_SUCCESS,
  payload: {
    horses: data.horses,
  },
});

export const fetchHorsesFailure = () => ({
  type: FETCH_ADDITIONAL_HORSES_FAILURE,
});

export const fetchHorsesRequest = () => ({
  type: FETCH_ADDITIONAL_HORSES_REQUEST,
});

export const fetchHorses = (token, data) => dispatch => {
  dispatch(fetchHorsesRequest());

  return fetchApi({
    path: '/horses/search',
    method: 'post',
    token,
    body: JSON.stringify(data),
    dispatch,
    cb: fetchHorsesSuccess,
    fb: fetchHorsesFailure,
  });
};

/**
 * Create horse
 */
export const createHorseSuccess = (resolve, data) => dispatch => {
  resolve();

  dispatch({
    type: CREATE_ADDITIONAL_HORSE_SUCCESS,
    payload: {
      horse: data.horse,
    },
  });
};

export const createHorseFailure = reject => dispatch => {
  reject();

  dispatch({
    type: CREATE_ADDITIONAL_HORSE_FAILURE,
  });
};

export const createHorseRequest = () => ({
  type: CREATE_ADDITIONAL_HORSE_REQUEST,
});

export const createHorse = (token, data) => dispatch => {
  dispatch(createHorseRequest());

  return new Promise((resolve, reject) => {
    fetchApi({
      path: '/horses',
      method: 'post',
      token,
      body: JSON.stringify(data),
      dispatch,
      cb: createHorseSuccess.bind(this, resolve),
      fb: createHorseFailure.bind(this, reject),
    });
  });
};

/**
 * Delete horse
 */
export const deleteHorseSuccess = (resolve, data) => dispatch => {
  resolve();

  dispatch({
    type: DELETE_ADDITIONAL_HORSE_SUCCESS,
    payload: {
      horse: data.horse,
    },
  });
};

export const deleteHorseFailure = reject => dispatch => {
  reject();

  dispatch({
    type: DELETE_ADDITIONAL_HORSE_FAILURE,
  });
};

export const deleteHorseRequest = () => ({
  type: DELETE_ADDITIONAL_HORSE_REQUEST,
});

export const deleteHorse = (token, horseId) => dispatch => {
  dispatch(deleteHorseRequest());

  return new Promise((resolve, reject) => {
    fetchApi({
      path: `/horses/${horseId}`,
      method: 'delete',
      token,
      dispatch,
      cb: deleteHorseSuccess.bind(this, resolve),
      fb: deleteHorseFailure.bind(this, reject),
    });
  });
};

/**
 * Edit horse
 */
export const editHorseSuccess = (resolve, data) => dispatch => {
  resolve();

  dispatch({
    type: EDIT_ADDITIONAL_HORSE_SUCCESS,
    payload: {
      horse: data.horse,
    },
  });
};

export const editHorseFailure = reject => dispatch => {
  reject();

  dispatch({
    type: EDIT_ADDITIONAL_HORSE_FAILURE,
  });
};

export const editHorseRequest = () => ({
  type: EDIT_ADDITIONAL_HORSE_REQUEST,
});

export const editHorse = (token, horseId, data) => dispatch => {
  dispatch(editHorseRequest());

  return new Promise((resolve, reject) => {
    fetchApi({
      path: `/horses/${horseId}`,
      method: 'put',
      token,
      body: JSON.stringify(data),
      dispatch,
      cb: editHorseSuccess.bind(this, resolve),
      fb: editHorseFailure.bind(this, reject),
    });
  });
};



// WEBPACK FOOTER //
// ./src/actions/additionalHorses.js